import './../styles/code.css';
import KONAMI_LOGO from './../assets/images/konami-logo.png';
import { useState } from 'react';
import { ClipLoader } from 'react-spinners';
import ToastNotification, { showTopCenterToast } from '../components/toasts/ToastNotification';
import { getOtpCode } from '../api/gmail.api';
import OtpCodeModal from '../components/modal/otp-code-modal';

export const Code = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [otpCode, setOtpCode] = useState("");

    const handleRetrieveCode = async () => {
        try {
            setLoading(true);

            if (!email || !password) {
                showTopCenterToast("Vui lòng điền vào các trường", "error");
                setLoading(false);
                return;
            }

            const res = await getOtpCode(email, password);

            if (res.success) {
                setIsModalOpen(true);
                setOtpCode(res.data.otp);
            }
        } catch (error) {
            showTopCenterToast(error.message, "error");
        }
        finally {
            setLoading(false);
        }
    }
    return (
        <div className='konami-code-container'>
            <ToastNotification />
            <OtpCodeModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} otp={otpCode}/>
            <div className='konami-code-wrapper'>
                <img className='konami-logo' src={KONAMI_LOGO} alt='Konami Logo'></img>
                <div className='tutorial-container'>
                    <h3>Hướng dẫn lấy code</h3>
                    <p>
                        Bước 1: Truy cập vào trang Konami để thay đổi thông tin
                        <span className='konami-page-link' onClick={() => window.open("https://my.konami.net/en_GB", "_blank")}>
                            tại đây
                        </span>
                    </p>
                    <p>Bước 2: Dán tài khoản và mật khẩu Gmail sau đó ấn lấy mã</p>
                    <p>Bước 3: Copy mã và vào trang Konami để hoàn tất thay đổi thông tin tài khoản</p>
                </div>
                <div className='verify-email-container'>
                    <h3>Nhập thông tin tài khoản</h3>
                    <input onChange={(e) => setEmail(e.target.value)} required type='text' className='verify-email-input' placeholder='Nhập email'></input>
                    <input onChange={(e) => setPassword(e.target.value)} required type='text' className='verify-email-input' placeholder='Nhập mật khẩu'></input>
                    <button
                        onClick={handleRetrieveCode}
                        disabled={loading}
                        className={`retrieve-code-button ${loading && "disabled-button"}`}>
                        {loading ? <ClipLoader size={20} color='#fff' /> : "Lấy code"}
                    </button>
                </div>
            </div>
        </div>
    )
}